import { AppStatusFilterValues } from '../../../hooks/react-query/use-vehicle-offers-event-descriptions/use-vehicle-offers-event-descriptions.types';
import { CircleCloseIcon } from '../../icons-new/circle-close-icon';
import React from 'react';
import { useTheme } from 'styled-components';
import { CheckedIcon } from '../../icons-new/checked-icon';
import { DocumentIcon } from '../../icons-new/document';

const useTargetEventColorAndIcon = (isDone: boolean, appStatusFilterValue?: AppStatusFilterValues) => {
  const theme = useTheme();

  if (appStatusFilterValue === AppStatusFilterValues.Archived) {
    return {
      targetEventColor: 'pink',
      targetEventIcon: <CircleCloseIcon color={theme.colors.pink} width='18' height='18' />,
      space: '7'
    };
  }
  if (isDone) {
    return {
      targetEventColor: 'green',
      targetEventIcon: <CheckedIcon color={theme.colors.green} width='15' height='15' />,
      space: '10'
    };
  }
  return {
    targetEventColor: 'grey600',
    targetEventIcon: <DocumentIcon color={theme.colors.grey600} width='12' height='14' />,
    space: '10'
  };
};

export default useTargetEventColorAndIcon;
